<script setup></script>

<template>
  <div class="m-headingForT-section">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
  @use '@/assets/scss/microsites/DemonSlayerCollab/variables.scss' as *;

  .m-headingForT-section {
    position: relative;
    padding: 5.7vw 0;
    &:after {
      content: '';
      left: 0;
      bottom: 0;
      position: absolute;
      width: 100%;
      height: 7.5vw;
      transform: translateY(50%);
      background: url('~@/assets/images/microsites/headingfortomorrow/_components/section-wrapper/divider.png')
        no-repeat center center / 100% auto;
      z-index: 15;
    }
  }
  .tablet {
    .m-headingForT-section {
      padding: 8.7vw 0;
      &:after {
        height: 15vw;
        background: url('~@/assets/images/microsites/headingfortomorrow/_components/section-wrapper/divider.png')
          no-repeat center center / 220% auto;
        z-index: 15;
      }
    }
  }
  .mobile {
    .m-headingForT-section {
      padding: 8.7vw 0;
      &:after {
        height: 11vw;
        background: url('~@/assets/images/microsites/headingfortomorrow/_components/section-wrapper/divider-mobile.png')
          no-repeat center center / 100% auto;
        z-index: 15;
      }
    }
  }
</style>
